<template>
  <div class="contact">
    <baidu-map class="bm-view" :center="center" :zoom="zoom" :point="center" :mapStyle="mapStyle" @ready="handler">
      <bm-marker :position="marker" :dragging="false" @click="infoWindowOpen">
        <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">宁波博洋纺织科技有限公司</bm-info-window>
      </bm-marker>
    </baidu-map>
    <div class="w1320">
      <div class="contact-wrap">
        <div class="logo">
          <img src="@/assets/images/p4.png" alt="">
        </div>
        <div class="title"></div>
        <div class="item">
          <div class="tit">Address</div>
          <div class="text">浙江省宁波市江北区望山路218弄26号博瑞大厦12楼</div>
        </div>
        <div class="item">
          <div class="tit">Affiliate</div>
          <div class="text">0574-83892105</div>
        </div>
        <div class="item">
          <div class="tit">Group Purchase Hotline</div>
          <div class="text">400-885-5208</div>
        </div>
        <div class="qrcode">
          <img src="@/assets/images/qrcode.jpg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      center: {lng: 0, lat: 0},
      marker: {lng: 0, lat: 0},
      zoom: 3,
      mapStyle:{
        features: ["road", "building","water","land"],//隐藏地图上的poi
        style : "dark"  //设置地图风格为高端黑
      },
      show:true
    }
  },
  methods: {
    handler ({BMap, map}) {
      console.log(BMap, map)
      this.center.lng = 121.454165
      this.center.lat = 29.95168
      this.marker.lng = 121.474165
      this.marker.lat = 29.95168
      this.zoom = 15
    },
    infoWindowClose () {
      this.show = false
    },
    infoWindowOpen () {
      this.show = true
    }
  }
}
</script>

<style scoped>
.contact{
  position: relative;
}
.bm-view {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.contact-wrap{
  position: relative;
  background-color: #5e7987;
  width: 580px;
  max-width: 100%;
  padding: 200px 50px 150px;
  text-align: center;
  color: #fff;
}
.contact-wrap .logo img{
  max-width: 100%;
}
.contact-wrap .title{
  font-size: 20px;
  padding: 30px 0;
}
.contact-wrap .item{
  padding: 30px 0;
  border-bottom: 1px solid rgba(121,197,237,.2);
}
.contact-wrap .item .tit{
  font-family: 'Embassy BT';
  font-size: 20px;
}
.contact-wrap .item .text{
  font-size: 14px;
  margin-top: 10px;
}
.contact-wrap .qrcode{
  margin-top: 100px;
}
.contact-wrap .qrcode img{
  max-width: 100%;
}
@media(max-width: 768px){
  .bm-view{
    height: 400px;
    position: static;
  }
  .contact-wrap{
    padding: 50px 20px;
  }
}
</style>


